
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { configOrderProcess } from '@/api/templateEvaluate';
import { getUserInfo } from '@/api/users';
import { UserModule } from '@/store/modules/user';
import { checkPermissionCompany } from '@/utils/permission';
import { Type } from '@/types/permissionType';
import TemplateAddress from '@/views/template/TemplateAddress.vue';

@Component({
  name: 'SystemSettingOrderProcess',
  components: {
    TemplateAddress

  }
})
export default class extends Vue {
  @Prop({
    type: Object,
    default: () => ({}),
    required: true
  })
  listData!: any;

  @Prop({
    type: String,
    default: '0'
  })
  type!: string; // 2 维保 3 安装 4 巡检 1 其他

  @Prop({
    type: Object,
    default: () => ({}),
    required: true
  })
  selectedData!: {};

  private isShow: any = {
    '2': false,
    '3': false,
    '4': false,
    '1': true
  }
  private isOpen: any = false;
  private permissionType = Type;

  private eorderValue: any = []; // 此处二级 电子工单 暂做尝试
  private visitValue: any = []; // 此处三级 任务处理-上门-签到/预约时间
  private taskReceiveDeal: any = [] // 任务处理 --- 接单及处理 --- 无处理方式/默认处理方式
  private orderReceiveDeal: any = [] // 订单处理---指派----任务协同完成

  private moduleAlias: any = []

  private hide = '9'
  private optional = '1'
  private must = '2'
  private reportOrder = 'order_config'
  private addOrder = 'add_order_config'
  private handleOrder = 'fix_config'
  private handleTask = 'task_config'
  private uploadData: any = [];

  private configData() {
    // 此处使用延迟加载 处理逻辑 需要进一步确认 学习
    // setTimeout(() => {}, 0.1 * 1000);
    // 二级 电子工单 与三级 上门 设置
    this.eorderValue = [];
    this.visitValue = [];
    this.taskReceiveDeal = [];
    this.orderReceiveDeal = [];
    let eorderValuea = [];
    let dataSource = this.selectedData as any;
    if (dataSource) {
      let eOrderConfig = dataSource.ls450000;
      if (eOrderConfig) {
        if (eOrderConfig.eorder_config === '1') {
          eorderValuea.push('A4');
        } else if (eOrderConfig.eorder_config === '2') {
          eorderValuea.push('A5');
        }
        if (eOrderConfig.repair_signature === '1') eorderValuea.push('bq');
        if (eOrderConfig.major_signature === '1') eorderValuea.push('wq');
      }
      this.eorderValue = eorderValuea;

      // 新版赋值
      for (let t = 0; t < eorderValuea.length; t++) {
        if (eorderValuea[t] === 'A4' || eorderValuea[t] === 'A5') {
          this.radioSecondElec = eorderValuea[t];
        }
        if (eorderValuea[t] === 'bq') {
          this.selectedSecondElectro.push(eorderValuea[t])
        }
        if (eorderValuea[t] === 'wq') {
          this.selectedSecondElectro.push(eorderValuea[t])
        }
      }

      let visitConfig = dataSource.ls202020;
      let taskDealConfig = dataSource.ls202090;
      let orderDealConfig = dataSource.ls153020;
      if (visitConfig) {
        //20240919 上门及时间在会员级别可设置 设置拉取的系统的与用户实际的不一致 重新组织数据
        if(this.listData.authConfig && this.listData.authConfig.ls202020){
          for (let t = 0; t < this.listData.authConfig.ls202020.length; t++) {
            const element = this.listData.authConfig.ls202020[t];
            if(visitConfig[element.key]=='1'){
              this.visitValue.push(t)
            }
          }
        }
        // if (visitConfig.checkin_config === '1') this.visitValue.push(0);
        // if (visitConfig.visittime_config === '1') this.visitValue.push(1);
      }
      if (taskDealConfig) {
        if (taskDealConfig.no_processing === '1') this.taskReceiveDeal.push(0);
        if (taskDealConfig.default_processing === '1') this.taskReceiveDeal.push(1);
      }
      if (orderDealConfig) {
        if (orderDealConfig.task_cooperate === '1') this.orderReceiveDeal.push(0);
      }
    }
  }

  private activeNameLatest = 'left'
  private windowHg = window.innerHeight - 280;
  private windowH = window.innerHeight - 140;
  private tableDataSecondElec: any = []
  private radioSecondElec: any = ''
  private selectedSecondElectro: any = []
  private tableDataProcess: any = []
  private tableDataModule: any = []

  private selectedSecondElec(val:any) {
    this.radioSecondElec = this.radioSecondElec === val ? '' : val;
  }

  private isHaveCustomer: boolean = true;

  // LIfe circle
  private created() {
    this.tableDataProcess = Object.values(this.listData.process);
    this.tableDataSecondElec = this.listData.authConfig.ls450000;
    if (parseInt(this.type) === 4) { // 巡检单
      this.windowHg = window.innerHeight - 340;
      this.windowH = window.innerHeight - 200;
      let { A5, ...other } = this.tableDataSecondElec;
      this.tableDataSecondElec = other;
    }

    setTimeout(() => {
      this.configData();
    }, 1.2 * 1000);
    // // 开启判断
    if (this.type === '1') {
      this.isOpen = checkPermissionCompany(UserModule.getCompanyId, this.permissionType.OtherOpen);
    }
    if (this.type === '2') {
      this.isHaveCustomer = checkPermissionCompany(UserModule.getCompanyId, this.permissionType.CUSTOMER_COMPANY);
    }

    // 订单内容分组
    let arr1 = [];
    let arr3 = [];
    let arr5 = [];
    let arr7 = [];
    let arr0 = [];
    for (let p = 0; p < this.listData.module.length; p++) {
      if (this.listData.module[p].process_type === '1') {
        arr1.push(this.listData.module[p]);
      } else if (this.listData.module[p].process_type === '3') {
        arr3.push(this.listData.module[p]);
      } else if (this.listData.module[p].process_type === '5') {
        arr5.push(this.listData.module[p]);
      } else if (this.listData.module[p].process_type === '7') {
        arr7.push(this.listData.module[p]);
      } else {
        //如果是巡检 有客户的专维 不显示报修部门
        if( parseInt(this.type) === 4 && checkPermissionCompany(UserModule.getCompanyId, this.permissionType.CUSTOMER_COMPANY) && this.listData.module[p].module_code == "ls941000"){
          continue;
        }
        arr0.push(this.listData.module[p]);
      }
    }
    let title1: any = [];
    if (arr1.length > 0) {
      title1 = [{
        module_name: '报修方信息',
        module_code: '',
        process_type: 'title',
      }];
    } else {
      title1 = []
    }
    let title3: any = [];
    if (arr3.length > 0) {
      title3 = [{
        module_name: '故障信息',
        module_code: '',
        process_type: 'title',
      }];
    } else {
      title3 = []
    }
    let title5:any = [];
    if (arr5.length > 0) {
      title5 = [{
        module_name: '维修信息',
        module_code: '',
        process_type: 'title',
      }]
    } else {
      title5 = []
    }
    let title7: any = [];
    if (arr7.length > 0) {
      title7 = [{
        module_name: '其他信息',
        module_code: '',
        process_type: 'title',
      }];
    } else {
      title7 = [];
    }
    this.tableDataModule = [...arr0, ...title1, ...arr1, ...title3, ...arr3, ...title5, ...arr5, ...title7, ...arr7];
  }

  /**
   * 左侧设置选择
  */
  // 处理一级 处理订单、任务  任务完订单完  生成报价单 电子工单
  private handleOneLevel(have: any, item: any) {
    let dataSource = this.selectedData as any;
    if (have) { // 一级 选中
      if (item.module_code === 'ls450000') {
        // 选中电子工单模块 取消任务完订单完
        dataSource.ls210000.have = false;
        // 默认选中了  A5 维修端签字
        if (this.type === '4') this.eorderValue = ['A4', 'bq'];
        else this.eorderValue = ['A5', 'bq'];
      }
      if (item.module_code === 'ls210000') {
        // 选中任务完订单完 取消电子工单模块
        dataSource.ls450000.have = false;
        this.eorderValue = [];
      }
    } else { // 一级 取消选中
      for (var i = 0; i < item.child.length; i++) {
        dataSource[item.child[i].module_code].have = false;
      }
      if (item.module_code === 'ls450000') {
        this.eorderValue = [];
      }
      if (item.module_code === 'ls202000') {
        this.visitValue = [];
      }
      if (item.module_code === 'ls202090') {
        this.taskReceiveDeal = [];
      }
    }
  }
  // 处理二级 处理订单/处理任务
  // 注意 任务处理中 接单即处理与送远上寄转的冲突
  private handleTwoLevel(item:any) {
    let dataSource:any = this.selectedData as any;
    let have = dataSource[item.module_code].have
    if (have) { // 选中
      switch (item.module_code) {
        case 'ls202090':
          dataSource.ls202070.have = false;
          dataSource.ls202010.have = false;
          dataSource.ls202020.have = false;
          dataSource.ls202030.have = false;
          dataSource.ls202040.have = false;
          this.visitValue = [];
          dataSource.ls202090.have = true;
          break;
        case 'ls202070':
          if (this.taskReceiveDeal && this.taskReceiveDeal.length > 0 && this.taskReceiveDeal[0] === 1) {
            dataSource.ls202010.have = false;
            dataSource.ls202020.have = false;
            dataSource.ls202030.have = false;
            this.visitValue = [];
            return;
          }
          dataSource.ls202090.have = false;
          this.taskReceiveDeal = [];
          break;
        case 'ls202010':
          if (this.taskReceiveDeal && this.taskReceiveDeal.length > 0 && this.taskReceiveDeal[0] === 1) {
            dataSource.ls202070.have = false;
            dataSource.ls202020.have = false;
            dataSource.ls202030.have = false;
            this.visitValue = [];
            return;
          }
          dataSource.ls202090.have = false;
          this.taskReceiveDeal = [];
          break;
        case 'ls202020':
          if (this.taskReceiveDeal && this.taskReceiveDeal.length > 0 && this.taskReceiveDeal[0] === 1) {
            dataSource.ls202070.have = false;
            dataSource.ls202010.have = false;
            dataSource.ls202030.have = false;
            return;
          }
          dataSource.ls202090.have = false;
          this.taskReceiveDeal = [];
          break;
        case 'ls202030':
          if (this.taskReceiveDeal && this.taskReceiveDeal.length > 0 && this.taskReceiveDeal[0] === 1) {
            dataSource.ls202070.have = false;
            dataSource.ls202010.have = false;
            dataSource.ls202020.have = false;
            this.visitValue = [];
            return;
          }
          dataSource.ls202090.have = false;
          this.taskReceiveDeal = [];
          break;
        case 'ls202040':
          dataSource.ls202090.have = false;
          this.taskReceiveDeal = [];
          break;
        case 'ls202080':
          // dataSource.ls202090.have = false;
          this.orderReceiveDeal = [];
          break;
      }
      dataSource[item.module_code].have = true;
    } else { // 取消选择
      if (item.child && item.child.length > 0) {
        for (var i = 0; i < item.child.length; i++) {
          dataSource[item.child[i].module_code].have = false;
        }
      }
      if (item.module_code === 'ls202020') {
        this.visitValue = [];
      }
    }
  }
  // 三级选择 任务处理-上门-签到/预约时间
  private handleThreeLevel(code: any, item:any) {
    let dataSource = this.selectedData as any;
    if (code === 'ls202020') {
      if (this.visitValue.length > 0) {
        dataSource[code].have = true;
        // 赵子龙 说 签到 不控制 寄修 送修 远程的勾选
        // dataSource.ls202070.have = false;
        // dataSource.ls202010.have = false;
        // dataSource.ls202030.have = false;
        if (this.taskReceiveDeal && this.taskReceiveDeal.length > 0 && this.taskReceiveDeal[0] === 0) {
          dataSource.ls202090.have = false;
          this.taskReceiveDeal = [];
        }
        // 默认处理方式 只能选一个
        if (this.taskReceiveDeal && this.taskReceiveDeal.length > 0 && this.taskReceiveDeal[0] === 1) {
          dataSource.ls202070.have = false;
          dataSource.ls202010.have = false;
          dataSource.ls202030.have = false;
        }
      }
    }

    if (code === 'ls202090' && this.taskReceiveDeal.length > 0) { // 说明是选中
      if (item.key === 'default_processing') {
        this.taskReceiveDeal = [1];
      } else if (item.key === 'no_processing') {
        this.taskReceiveDeal = [0];
      } else {
        this.taskReceiveDeal = [];
      }
      if (this.taskReceiveDeal && this.taskReceiveDeal.length > 0 && this.taskReceiveDeal[0] === 1) {
        dataSource.ls202070.have = false;
        dataSource.ls202010.have = true;
        dataSource.ls202020.have = false;
        dataSource.ls202030.have = false;
        dataSource[code].have = true;
        this.visitValue = [];
      } else {
        dataSource.ls202070.have = false;
        dataSource.ls202010.have = false;
        dataSource.ls202020.have = false;
        dataSource.ls202030.have = false;
        dataSource[code].have = true;
        this.visitValue = [];
      }
    }

    if (code === 'ls153020') {
      if (this.orderReceiveDeal.length > 0) {
        dataSource[code].have = true;
        dataSource['ls202080'].have = false;
      }
    }
  }

  /**
    * 右侧订单内容选项 元素的展示判断
    * 判断 不显示 选填 必填  使用selectedData[code] 对应的config
    * 但是判断 radio-group的元素 使用listData.moduleAuth[code] 对应的config
  */
  private isShowRadio(code: any, handleType: string) {
    let config = (this.listData as any).moduleAuth;
    if (config[code][handleType] === 0) return false;
    return true;
  }

  // 右侧订单内容选项 此事件为测试 观察radiobtn点击后 数据的变化
  private clickToChange(val: any) {

  }

  // { row, column, rowIndex, columnIndex }
  private arraySpanMethod(IOrderColspan:any) {
    let dataSource = (this.listData as any);
    let row = IOrderColspan.row;
    if (row.process_type !== 'title') {
      if (!parseInt(dataSource.moduleAuth[row.module_code].order_config)) {
        if (IOrderColspan.columnIndex === 1) {
          return [1, 3];
        } else if (IOrderColspan.columnIndex === 2 || IOrderColspan.columnIndex === 3) {
          return [0, 0];
        }
      }
      if(!(parseInt(this.type)===2 && !this.isHaveCustomer)){
        if (!parseInt(dataSource.moduleAuth[row.module_code].add_order_config)) { // 添加订单
          if (IOrderColspan.columnIndex === 4) {
            return [1, 3];
          } else if (IOrderColspan.columnIndex === 5 || IOrderColspan.columnIndex === 6) {
            return [0, 0];
          }
        }

        if (!parseInt(dataSource.moduleAuth[row.module_code].fix_config)) {
          if (IOrderColspan.columnIndex === 7) {
            return [1, 3];
          } else if (IOrderColspan.columnIndex === 8 || IOrderColspan.columnIndex === 9) {
            return [0, 0];
          }
        }

        if (!parseInt(dataSource.moduleAuth[row.module_code].task_config)) {
          if (IOrderColspan.columnIndex === 10) {
            return [1, 3];
          } else if (IOrderColspan.columnIndex === 11 || IOrderColspan.columnIndex === 12) {
            return [0, 0];
          }
        }
      }else{
        if (!parseInt(dataSource.moduleAuth[row.module_code].fix_config)) { // 添加订单
          if (IOrderColspan.columnIndex === 4) {
            return [1, 3];
          } else if (IOrderColspan.columnIndex === 5 || IOrderColspan.columnIndex === 6) {
            return [0, 0];
          }
        }

        if (!parseInt(dataSource.moduleAuth[row.module_code].task_config)) {
          if (IOrderColspan.columnIndex === 7) {
            return [1, 3];
          } else if (IOrderColspan.columnIndex === 8 || IOrderColspan.columnIndex === 9) {
            return [0, 0];
          }
        }
      }
   
    } else {
      return [1, 13];
    }
  }

  private loading = false
  // 点击保存
  private clickToSave() {
    this.loading = true;
    this.uploadData = [];
    // 右侧 订单内容选项配置
    let process = (this.listData as any).process;
    let modules = (this.listData as any).module;
    let dataSource = (this.selectedData as any);
    for (const item of modules) {
      let code = item.module_code;
      let config = dataSource[code];

      let newConfig: any = {};
      newConfig.code = code;
      newConfig.order_config = config.order_config;
      newConfig.add_order_config = config.add_order_config;
      newConfig.fix_config = config.fix_config;
      newConfig.task_config = config.task_config;
      this.uploadData.push(newConfig);
    }

    // 左侧模块配置
    for (const key in process) {
      let code = process[key].module_code;
      let config = dataSource[code];
      if (config.have) {
        // 一级
        let newConfig: any = {};

        if (code === 'ls450000') { // 电子工单配置
          let info: any = [];
          // 新版电子工单数据
          if (!this.radioSecondElec) {
            if (this.type === '4') info.push({ 'name': 'eorder_config', 'value': '1' });
            else info.push({ 'name': 'eorder_config', 'value': '2' });
          } else {
            info.push({ 'name': 'eorder_config', 'value': this.radioSecondElec === 'A4' ? '1' : '2' });
          }
          info.push({ 'name': 'repair_signature', 'value': this.selectedSecondElectro.includes('bq') ? '1' : '0' });
          info.push({ 'name': 'major_signature', 'value': this.selectedSecondElectro.includes('wq') ? '1' : '0' });

          newConfig.config = info;
          newConfig.code = code;
          this.uploadData.push(newConfig);
        } else {
          newConfig.code = code;
          this.uploadData.push(newConfig);
        }
        // 二级
        for (const item of process[key].child) {
          let code = item.module_code;
          let config = dataSource[code];
          if (config.have) {
            let newConfig: any = {};
            if (code === 'ls202020') { // 上门配置
              let info: any = [];
              // info.push({ 'name': 'checkin_config', 'value': this.visitValue.includes(0) ? '1' : '0' });
              // info.push({ 'name': 'visittime_config', 'value': this.visitValue.includes(1) ? '1' : '0' });
               //20240919 上门及时间在会员级别可设置 设置拉取的系统的与用户实际的不一致 重新组织数据
              if(this.listData.authConfig && this.listData.authConfig.ls202020){
                for (let t = 0; t < this.listData.authConfig.ls202020.length; t++) {
                  const element = this.listData.authConfig.ls202020[t];
                  info.push({ 'name': element.key, 'value': this.visitValue.includes(t) ? '1' : '0' });
                }
              }
              newConfig.config = info;
              newConfig.code = code;
              this.uploadData.push(newConfig);
            } else if (code === 'ls202090') { // 接单及处理
              let info: any = [];
              info.push({ 'name': 'no_processing', 'value': this.taskReceiveDeal.includes(0) ? '1' : '0' });
              info.push({ 'name': 'default_processing', 'value': this.taskReceiveDeal.includes(1) ? '1' : '0' });
              newConfig.config = info;
              newConfig.code = code;
              this.uploadData.push(newConfig);
            } else if (code === 'ls153020') { // 指派
              let info: any = [];
              info.push({ 'name': 'task_cooperate', 'value': this.orderReceiveDeal.includes(0) ? '1' : '0' });
              newConfig.config = info;
              newConfig.code = code;
              this.uploadData.push(newConfig);
            } else {
              newConfig.code = code;
              this.uploadData.push(newConfig);
            }
          }
        }
      }
    }
    let params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      is_open: this.isOpen ? 1 : 0,
      type: this.type,
      module: this.uploadData
    };
    configOrderProcess(params).then(async(res) => {
      this.loading = false;
      let parameters: any = {};
      parameters.user_id = UserModule.getUserId;
      parameters.company_id = UserModule.getCompanyId;
      await getUserInfo(parameters).then(async(res) => {
        await UserModule.setLogin(res.data);
      });
      this.showSuccessMsg('设置成功');
    }).catch(err => {
      this.loading = false;
      this.showErrorMsg(err.msg);
    });
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
